export type ThemeEffect = 'none' | 'print';

export const THEME_EFFECTS: ThemeEffect[] = [
  'none',
  'print'
];

export const DEFAULT_THEME_EFFECT: ThemeEffect = 'none';

export function isThemeEffect(value: unknown): value is ThemeEffect {
  return typeof value === 'string' && (THEME_EFFECTS as string[]).includes(value);
}
export const THEME_EFFECT_METADATA: Record<ThemeEffect, { label: string; description: string }> = {
  none: { label: 'None', description: 'Use the base theme surfaces without extra styling.' },
  print: { label: 'Halftone', description: 'Retro halftone overlay for content backgrounds.' },
};

export type ThemeEffectPreview = Record<string, string>;

export const THEME_EFFECT_PREVIEWS: Record<ThemeEffect, ThemeEffectPreview> = {
  none: {
    background: 'linear-gradient(135deg, #e2e8f0 0%, #cbd5f5 100%)'
  },
  print: {
    backgroundColor: '#0f172a',
    backgroundImage:
      'radial-gradient(circle at 3px 3px, rgba(0, 0, 0, 0.5) 1.4px, transparent 0), radial-gradient(circle at 5px 5px, rgba(255, 255, 255, 0.2) 1px, transparent 0)',
    backgroundSize: '7px 7px',
    color: '#e2e8f0'
  }
};
